import {DeleteUserService, ConfirmSignUpCodeService} from "../Infrastructure/User.service";

export async function DeleteUserLogic(data){
  return DeleteUserService(data)
}

export async function ConfirmSignUpCodeLogic({id, code, data}){
  return ConfirmSignUpCodeService({id, code, data});
}